import React from "react";
import { useForm } from "react-final-form";
import { required } from "react-admin";
import { SelectInput } from "react-admin";
import { ICountryAppData } from "../../../common/redux/reducers/appDataReducer";
import "./StateSelector.css";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface IStateSelectorProps {
  formData: any;
  countries: ICountryAppData[];
  scopedFormData?: any;
  getSource?: ((source: string) => string) | undefined;
}

export const StateSelector = (props: IStateSelectorProps) => {
  const { formData, countries, ...rest } = props;
  const form = useForm();
  const choices =
    countries.find((x) => x.id === formData.countryId)?.states ?? [];

  return (
    <div className="state-selector-container">
      <ProtectedElement source="countryId">
        <SelectInput
          source="countryId"
          label="resources.common.labels.country"
          validate={required()}
          choices={countries}
          onChange={() => form.change("stateId", null)}
          {...rest}
        />
      </ProtectedElement>
      <ProtectedElement source="stateId">
        <SelectInput
          source="stateId"
          label="resources.common.labels.state"
          validate={required()}
          choices={choices}
          {...rest}
        />
      </ProtectedElement>
    </div>
  );
};
